import type { IRegional } from "./entidades/IRegional";
import type { IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";

export class RegionalModelo {
    

    constructor() { }
    public async obtenerListaRegionales(): Promise<IRespuestaApiLista<IRegional>> {
        const { data } = await api.get(
            `/api/Regionales/Listar`, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

    public async crearRegional(Regional: IRegional): Promise<IRespuestaApiObjeto<IRegional>> {
        const { data } = await api.post(
            `/api/Regionales/Crear`, Regional, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async editarRegional(Regional: IRegional): Promise<IRespuestaApiObjeto<IRegional>> {
        const { data } = await api.put(
            `/api/Regionales/Actualizar`, Regional, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async eliminarRegional(Regional: IRegional): Promise<IRespuestaApiObjeto<IRegional>> {
        const { data } = await api.delete(
            `/api/Regionales/Actualizar/${Regional.Id}`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

}

